import { getVisitorLog } from '@/helper/getVisitorLog'
import { commonRequest } from '@/services/common.request'
import { useUserState } from '@/states/user.state'
import { VisitorType } from '@/types/all.types'
import { DEBUGGER } from '@/helper/helper'

// 477 status code if payload is empty for visitor log
export default async function initializeGuest() {
  const userState = useUserState.getState()

  try {
    const visitorData = getVisitorLog({
      queryParams: userState.queryParams,
      version: userState.version,
      visitorToken: userState.guestToken || null,
    })

    let reSendStore = false
    const params = Object.fromEntries(new URLSearchParams(window.location.search))
    if (userState.guestToken !== visitorData.currentVisitorToken) {
      reSendStore = true
    } else {
      const savedParams = userState ? JSON.parse(userState.queryParams as string) : null

      const referrer = document.referrer
      const isExternalReferral = referrer && !referrer.includes(process.env.NEXT_PUBLIC_SITE_HOST!)
      if (
        params?.gclid &&
        (params?.gclid !== savedParams?.gclid ||
          params?.keyword !== savedParams?.keyword ||
          params?.utm_source !== savedParams?.utm_source ||
          isExternalReferral)
      ) {
        reSendStore = true
      }
    }
    if (reSendStore) {
      await commonRequest.visitorInitialize(visitorData?.collectedData as VisitorType)
      userState.setQueryParams(JSON.stringify(visitorData?.collectedData))
      userState.setGuestToken(visitorData?.currentVisitorToken)
    }
  } catch (err) {
    DEBUGGER('Initialize Guest Log => ', err)
  }
}
